<script setup lang="ts">
import type { IProps } from './CompanyInfo.types'
import { COMPANY } from '@/domains/about/company/const/company.const'

defineProps<IProps>()

</script>

<template>
  <div class="company-info">
    <h6
      v-if="heading"
      class="company-info__heading"
    >
      {{ heading }}
    </h6>

    <p v-html="$t(COMPANY.address.text)" />

    <p
      v-if="contact"
      v-html="contact"
    />

    <p>
      <span v-html="$t(COMPANY.identificationNumbers.krs.text)" />
      <br>
      {{ $t(COMPANY.identificationNumbers.krs.label) }}
      {{ $t(COMPANY.identificationNumbers.krs.value) }}
      <br>
      {{ $t(COMPANY.identificationNumbers.nip.label) }}
      {{ $t(COMPANY.identificationNumbers.nip.value) }}
      <br>
      {{ $t(COMPANY.identificationNumbers.regon.label) }}
      {{ $t(COMPANY.identificationNumbers.regon.value) }}
      <br>
      {{ $t(COMPANY.identificationNumbers.bdo.label) }}
      {{ $t(COMPANY.identificationNumbers.bdo.value) }}
      <br>
      {{ $t(COMPANY.shareCapital.text) }}
    </p>
  </div>
</template>

<style scoped lang="scss">
.company-info {
  &__heading {
    @include body-1-medium;
    display: inline-block;
    margin-bottom: 1.6rem;
  }

  p {
    @include body-1;
    margin-bottom: 1.6rem;
    color: $text-300;

    :last-child {
      margin-bottom: 0;
    }
  }
}
</style>
